var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#EF9B14",
    d: "M30 15c0 3.31-1.073 6.37-2.89 8.851-2.728 3.728-7.137 2.316-12.11 2.316s-9.382 1.412-12.11-2.316C1.072 21.371 0 18.311 0 15 0 6.716 6.716 0 15 0c8.284 0 15 6.716 15 15z",
    transform: "translate(-290 -333) translate(260 198) translate(30 135)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB8200",
    d: "M15 26.167c4.973 0 9.382 1.412 12.11-2.316C28.928 21.371 30 18.311 30 15c0-.088-.002-.175-.003-.263L19.553 4.294l-10.355 8.6 2.12 2.135c.252.925 1.27 3.439 1.27 3.439L2.888 23.85C5.618 27.58 10.027 26.167 15 26.167z",
    transform: "translate(-290 -333) translate(260 198) translate(30 135)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#584B66",
    d: "M7.221 15.898L17.036 15.898 17.036 18.457 7.221 18.457z",
    transform: "translate(-290 -333) translate(260 198) translate(30 135) translate(2.871 1.7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A3E56",
    d: "M12.129 15.898L17.036 15.898 17.036 18.457 12.129 18.457z",
    transform: "translate(-290 -333) translate(260 198) translate(30 135) translate(2.871 1.7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFBB7D",
    d: "M8.846 13.564L15.412 13.564 15.412 20.527 8.846 20.527z",
    transform: "translate(-290 -333) translate(260 198) translate(30 135) translate(2.871 1.7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFBB7D",
    d: "M12.129 17.771L19.245 17.771 19.245 24.468 12.129 24.468z",
    transform: "translate(-290 -333) translate(260 198) translate(30 135) translate(2.871 1.7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7B7284",
    d: "M24.24 22.152c-2.73 3.728-7.138 6.149-12.111 6.149-4.974 0-9.382-2.421-12.11-6.149.074-2.432 2.07-4.381 4.52-4.381h4.307l3.283 3.147 3.283-3.147h4.307c2.451 0 4.446 1.948 4.52 4.381z",
    transform: "translate(-290 -333) translate(260 198) translate(30 135) translate(2.871 1.7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD4A6",
    d: "M17.614 7.157C17.383 3.64 14.537 2.34 12.13 2.34c-2.408 0-5.254 1.3-5.486 4.818-.622.12-1.065.937-.995 1.598l.107 1.503c.073.693.682 1.2 1.354 1.124l.116-.013c1.376 3.696 3.534 4.08 4.904 4.297 1.37-.216 3.528-.601 4.904-4.297l.116.013c.671.075 1.281-.43 1.354-1.124l.107-1.503c.07-.66-.373-1.477-.996-1.598z",
    transform: "translate(-290 -333) translate(260 198) translate(30 135) translate(2.871 1.7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D97A5",
    d: "M7.221 15.898L12.129 20.918 9.675 23.555 5.479 17.771z",
    transform: "translate(-290 -333) translate(260 198) translate(30 135) translate(2.871 1.7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F7887",
    d: "M17.036 15.898L12.129 20.918 14.583 23.555 18.779 17.771z",
    transform: "translate(-290 -333) translate(260 198) translate(30 135) translate(2.871 1.7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#494949",
    d: "M8.804.03S5.63 3.121 6.288 6.173l.458 3.04h1.26l.602-2.242c.214-.798 1.037-1.281 1.832-1.059.077.022.153.046.228.073l.22.078c.807.286 1.687.258 2.484-.053.16-.063.324-.113.49-.15.783-.18 1.568.295 1.777 1.072l.613 2.28h1.26l.456-3.165C18.066 3.335 15.885.03 8.804.03z",
    transform: "translate(-290 -333) translate(260 198) translate(30 135) translate(2.871 1.7)"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAvatar);
export default __webpack_public_path__ + "static/media/user-avatar.a19a648afbfe0b49f7b35885237f3111.svg";
export { ForwardRef as ReactComponent };